import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import ViewButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import { PRODUCTCOLOR_API } from '../../../../../Utilities/APIs/APIs';
import ViewProductColor from './ViewProductColor';
import CreateProductColor from './CreateProductColor';
import UpdateProductColor from './UpdateProductColor';
import { useParams } from 'react-router-dom';


function ProductColors() {

  const [productcolors, setProductColors] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)
  const axiosInstance = useAxiosInstance()
  const {productID} = useParams();

  useEffect(() => {

    async function fetchAndSetProducts() {
      const { data } = await axiosInstance.get(PRODUCTCOLOR_API +  'getProductColorsByProduct/' + productID)
      setProductColors(data)
    }
    fetchAndSetProducts()

  }, [toggleFetch, axiosInstance, productID])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>Product Colors ({productcolors?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'Product Colors'}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='Products' />
          <CRUDth th='Colors' />
          <CRUDth th='Action' />

        </CRUDTableHeader>
        <tbody>
          {
            productcolors?.map(productcolor =>
              <CRUDTableRow key={productcolor._id}>
                <ShortTextCell text={productcolor?.product?.name} />
                <ShortTextCell text={productcolor?.color?.name} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={productcolor._id}
                        setTargetID={setTargetID}
                      />

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={productcolor._id}
                        setTargetID={setTargetID}
                      />

                      <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={productcolor._id}
                        setTargetID={setTargetID}
                      />
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {
        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Add Product Color`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateProductColor
          productID={productID}
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
          />
        </Modal>
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update Product Color`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateProductColor
            productID={productID}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View Product Color`}
          setShowModalContent={setShowViewSection}
        >
          <ViewProductColor
            targetID={targetID}
          />
        </Modal>
      }
      {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete Product Color`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={PRODUCTCOLOR_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      }
    </>
  )
}

export default ProductColors